/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { PropertyType } from '../types/utils';

export class Property {
	key: string = ''

	properties?: Array<Property>

	type: PropertyType = PropertyType.RICH_TEXT

	value: string = ''
}